import { render, staticRenderFns } from "./transport-feedback.vue?vue&type=template&id=070e0a9e&scoped=true"
import script from "./transport-feedback.vue?vue&type=script&lang=js"
export * from "./transport-feedback.vue?vue&type=script&lang=js"
import style0 from "./transport-feedback.vue?vue&type=style&index=0&id=070e0a9e&prod&lang=less"
import style1 from "./transport-feedback.vue?vue&type=style&index=1&id=070e0a9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070e0a9e",
  null
  
)

export default component.exports